import React from 'react';
import { Link } from 'react-router-dom';
// import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notfound-page">
            <div className="container">
                <h1>404</h1>
                <h2>Page Not Found</h2>
                <p>The page you're looking for doesn't exist.</p>
                <Link to="/" className="btn btn-primary">Go Home</Link>
            </div>
        </div>
    );
};

export default NotFound;